import { render, staticRenderFns } from "./DeltaAssinantesCard.vue?vue&type=template&id=30012602"
import script from "./DeltaAssinantesCard.vue?vue&type=script&lang=ts"
export * from "./DeltaAssinantesCard.vue?vue&type=script&lang=ts"
import style0 from "./DeltaAssinantesCard.vue?vue&type=style&index=0&id=30012602&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports